export default __webpack_public_path__ + "static/media/pwc-logo-simple.1f884484.svg";